import React from 'react';
import PropTypes from "prop-types";
import { Link } from "gatsby";
import HomeIcon from "../../assets/svg/icons/home.inline.svg";

const Breadcrumbs = ({ breadcrumbs, pageUrl }) => {
  const separator = ' \\ ';
  return (
    <div className="breadcrumbs wrapper">
      <div className="bc-list">
        {breadcrumbs && breadcrumbs.length > 0 ?
          breadcrumbs.map((breadcrumb, index) =>
            <div key={index + breadcrumb.url} className="crumb">
              {breadcrumb.url.replace(/^\/category\//g, '/') !== pageUrl ?
                <>
                  <Link aria-label={breadcrumb.text ?? process.env.SEO_ORG_NAME} key={index + breadcrumb.url} to={breadcrumb.url.replace(/^\/category\//g, '/')}>
                    {breadcrumb.url === '/' ?
                      <HomeIcon/>
                      : <span dangerouslySetInnerHTML={{ __html: breadcrumb.text }} />
                    }
                  </Link>
                  <span className="sep">{separator}</span>
                </> : <span key="title" dangerouslySetInnerHTML={{ __html: breadcrumb.text }} />
              }
            </div>
          ) : ''}
      </div>
    </div>
  )
};

export default Breadcrumbs;

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
  pageUrl: PropTypes.string,
};
